export default function Footer() {
  return (
    <footer
      className="h-11 shrink-0 border-t border-slate-800 bg-slate-900/95 backdrop-blur-md flex items-center justify-center gap-2 px-4"
      data-testid="app-footer"
    >
      <span className="text-xs text-slate-500">Développé par</span>
      <a
        href="https://slaunay.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center cursor-pointer hover:opacity-80 transition-opacity duration-300"
        data-testid="footer-slaunay-link"
      >
        <img alt="SLAUNAY" className="h-6 sm:h-7 brightness-0 invert" src="/slaunay-logo.webp" />
      </a>
    </footer>
  );
}
